import { commonSelectors } from "../selector-template-generator";

export const adminsConfig = {
  fields: [
    {
      name: "email",
      label: "Login Email Id",
      type: "email",
    },
    { name: "name", label: "Full Name" },
    { name: "city", label: "City" },
    { name: "country", label: "Country", type: "country" },
    {
      name: "state",
      label: "State (India)",
      type: "indiastate",
      dynamic: [["hide", [":country", "!=", "India"]]],
    },
    {
      name: "x2",
      type: "statichtml",
      label: "<br/><br/>",
    },
    {
      name: "inactive",
      label: "Deactivated",
      type: "toggle",
    },
  ],

  collection: "CareAdmins",

  primaryKey: "email",

  defaults: {},
};

const adminsCollection = adminsConfig.collection;

export const adminsSelectors = () => commonSelectors(adminsConfig.collection);

export const postprocessAdmins = (r) => {
  const ret = { ...r };
  ret[adminsConfig.primaryKey] = r[adminsConfig.primaryKey]
    .toLowerCase()
    .trim();
  return ret;
};

export const validateAdmins = (/* r */) => "";

export const queryAdmins = () => ({
  collection: adminsCollection,
  orderBy: "name",
});
